import { PropertyManagementDTO } from "../DTO/propertyManagementDTO";

export interface WithVendor {
  vendorId?: number;
}

export type Management = OccupiedManagement | OccupantManagement | ElectricManagement | GasManagement | WaterManagement | SewerManagement | TrashManagement | InternetManagement | HOAManagement ;

export class OccupiedManagement {
    public occupied: number = 0; //0=unknown, 1=yes, 2=no
    public verification: boolean = false; //false=assumed, true=verified
    public dateChecked?:string

    public serialize(): any {
        return { ...this};
    }
    public static deserialize(raw: any): OccupiedManagement {
        return Object.assign(new OccupiedManagement(), raw);
    }
}

export class OccupantManagement {
    public unit?: number;
    public company?: string;
    public name?:string;
    public email?:string;
    public mobile?:string;
    public phone?:string;
    public officePhone?:string;
    public collectingRent:boolean = false;
    public cfk?:string;
    public eviction?:string;

    public serialize(): any {
        return { ...this };
    }
    public static deserialize(raw: any): OccupantManagement {
        return Object.assign(new OccupantManagement(), raw);
    }
}

export class ElectricManagement implements WithVendor {
    public service?: number; //0=n/a, 1=on, 2=off
    public accountHolder?: string;
    public vendorId?: number;

    public serialize(): any {
        return { ...this };
    }
    public static deserialize(raw: any): ElectricManagement {
       return Object.assign(new ElectricManagement(), raw);
    }
}

export class GasManagement implements WithVendor  {
    public service?: number; //0=n/a, 1=on, 2=off
    public accountHolder?: string;
    public vendorId?: number;

    public serialize(): any {
        return { ...this };
    }
    public static deserialize(raw: any): GasManagement {
       return Object.assign(new GasManagement(), raw);
    }
}

export class WaterManagement implements WithVendor  {
    public service?: number; //0=n/a, 1=on, 2=off
    public accountHolder?: string;
    public vendorId?: number;

    public serialize(): any {
        return { ...this };
    }
    public static deserialize(raw: any): WaterManagement {
       return Object.assign(new WaterManagement(), raw);
    }
}

export class SewerManagement implements WithVendor  {
    public service?: number; //0=n/a, 1=on, 2=off
    public accountHolder?: string;
    public vendorId?: number;

    public serialize(): any {
        return { ...this };
    }
    public static deserialize(raw: any): SewerManagement {
       return Object.assign(new SewerManagement(), raw);
    }
}

export class TrashManagement implements WithVendor  {
    public service?: number; //0=n/a, 1=on, 2=off
    public accountHolder?: string;
    public vendorId?: number;

    public serialize(): any {
        return { ...this };
    }
    public static deserialize(raw: any): TrashManagement {
       return Object.assign(new TrashManagement(), raw);
    }
}

export class InternetManagement implements WithVendor  {
    public service?: number; //0=n/a, 1=on, 2=off
    public accountHolder?: string;
    public vendorId?: number;

    public serialize(): any {
        return { ...this };
    }
    public static deserialize(raw: any): InternetManagement {
       return Object.assign(new InternetManagement(), raw);
    }
}

export class HOAManagement {
    public alarm: boolean = false;
    public hoaName?: string;
    public managementCo?: string;
    public website?:string;
    public contactName?:string;
    public email?:string;
    public phone?:string;
    public address?:string;
    public mobile?:string;
    public ein?:string;

    public serialize(): any {
        return { ...this };
    }
    public static deserialize(raw: any): HOAManagement {
       return Object.assign(new HOAManagement(), raw);
    }
    
}


export class PropertyManagement{
    public id?:number;
    public propertyId!:number;
    public managementType!:string;  //see map down below
    public management!:Management;

    public hasVendor(): boolean {
        return 'vendorId' in this.management && this.management['vendorId'] !== undefined;
    }

    constructor(){
    }

    public static managementTypeMap: Record<string, new () => Management> = {
        'occupied':                OccupiedManagement,
        'occupant':                OccupantManagement,
        'electric':                ElectricManagement,
        'gas':                     GasManagement,
        'water':                   WaterManagement,
        'sewer':                   SewerManagement,
        'trash':                   TrashManagement,
        'internet':                InternetManagement,
        'hoa':                     HOAManagement,
    };

    public static managementNameMap: Record<string, string> = {
        'occupied':                 'Occupied',
        'occupant':                 'Occupant Information',
        'electric':                 'Electric',
        'gas':                      'Gas',
        'water':                    'Water',
        'sewer':                    'Sewer',
        'trash':                    'Trash',
        'internet':                 'Internet',
        'hoa':                      'HOA',
    };

    public static managementSingularityMap: Record<string, boolean> = {
        'occupied':                 true,
        'occupant':                 false,
        'electric':                 true,
        'gas':                      true,
        'water':                    true,
        'sewer':                    true,
        'trash':                    true,
        'internet':                 true,
        'hoa':                      true,
    };

    public static mapToDTO(param: PropertyManagement): PropertyManagementDTO {
        ;
        let dto = new PropertyManagementDTO();
        try {
            dto.id = param.id;
            dto.propertyId = param.propertyId;
            dto.managementType = param.managementType;
            const data = (param.management as any)?.serialize
                ? (param.management as any).serialize()
                : param.management;
            dto.management = JSON.stringify(data, (key, value) => value ?? undefined);
        } catch (e) {
            console.log(e);
        }
        return dto;
    }

    public static mapFromDTO(param: PropertyManagementDTO): PropertyManagement {
        ;
        let obj = new PropertyManagement();
        try {
            obj.id = param.id;
            obj.propertyId = param.propertyId;
            obj.managementType = param.managementType;
            if (param.management) {
                const raw = JSON.parse(param.management);
                const TaskClass = PropertyManagement.managementTypeMap[param.managementType];
                if (TaskClass) {
                    obj.management = (TaskClass as any).deserialize
                        ? (TaskClass as any).deserialize(raw)
                        : Object.assign(new TaskClass(), raw);
                }
            }
        } catch (e) {
            console.log(e);
        }
        return obj;
    }
}

